<template>
  <div class="quotation-answer-forms" v-if="answers.length > 0">
    <hr />
    <div class="mb-3">
      <h6>Котировки по услуге</h6>
    </div>

    <div class="answers-horizontal-scroll">
        <div class="answers-container">
          <div 
            v-for="answer in answers.filter(a => selectedTransportTypes.includes(a.transport_types_id))" 
            :key="answer.id"
            class="transport-type-answer-card"
          >
          <div class="border rounded p-3">
            <h6 class="mb-3 d-flex justify-content-between align-items-center">
              <span>{{ getTransportTypeName(answer.transport_types_id) }}</span>
              <span class="badge" :class="getStatusBadgeClass(answer.status)">
                {{ getStatusText(answer.status) }}
              </span>
            </h6>

            <!-- Список существующих ответов для этого типа транспорта -->
            <div 
              v-if="answers.length > 0" 
              class="existing-answers mb-2"
            >
              <!-- Форма редактирования для статуса filling -->
               <div v-if="!showDataOnly && (orderReferenceStatusId === 541 || answer.status === 'filling') && isLogisticsManager">
                  <div class="answer-form border-top pt-3">
                    <b-form>
                      <b-row class="no-gutters align-items-end">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Стоимость доставки *" 
                            :invalid-feedback="getValidationErrorForField(answer.id, 'delivery_cost')" 
                            :state="!hasValidationErrorForField(answer.id, 'delivery_cost')" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.delivery_cost"
                              @input="normalizeDecimalInput($event, 'delivery_cost', answer)"
                              type="number"
                              step="0.01"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта доставки *"
                            :invalid-feedback="getValidationErrorForField(answer.id, 'currency_id')" 
                            :state="!hasValidationErrorForField(answer.id, 'currency_id')" 
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.currency_id"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                          label="НДС доставки (%) *" 
                          label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.vat_rate"
                              @input="normalizeDecimalInput($event, 'vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="20.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="no-gutters align-items-end">
                        <b-col :md="answer.conversion_type === 'cb_plus_percent' ? 4 : 6" class="pr-1">
                          <b-form-group 
                            label="Тип конвертации *" 
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.conversion_type"
                              :options="conversionTypeOptions"
                              size="sm"
                             ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1" v-if="answer.conversion_type === 'cb_plus_percent'">
                          <b-form-group 
                          label="Курс конвертации *" 
                          label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.conversion_rate"
                              @input="normalizeDecimalInput($event, 'conversion_rate', answer)"
                              type="number"
                              step="0.01"
                              placeholder="1.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col :md="answer.conversion_type === 'cb_plus_percent' ? 4 : 6">
                          <b-form-group 
                            label="Страховка (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.insurance_rate"
                              @input="normalizeDecimalInput($event, 'insurance_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.16"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="no-gutters" v-if="shouldShowSenderPickup(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Автовывоз со склада отправителя" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.pickup_sender_cost"
                              @input="normalizeDecimalInput($event, 'pickup_sender_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта автовывоза (со склада отправителя)"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.pickup_sender_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="НДС по автовывозу со склада отправителя (%)"
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.pickup_sender_vat_rate"
                              @input="normalizeDecimalInput($event, 'pickup_sender_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="no-gutters align-items-end">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Автовывоз до склада клиента (при необходимости)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.auto_pickup_cost"
                              @input="normalizeDecimalInput($event, 'auto_pickup_cost', answer)"
                              type="number"
                              step="0.01"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта автовывоза (при необходимости)"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.auto_pickup_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по автовывозу до склада клиента (%)"
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.auto_pickup_vat_rate"
                              @input="normalizeDecimalInput($event, 'auto_pickup_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="no-gutters align-items-end">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Транзитный срок (дни) *" 
                            :invalid-feedback="getValidationErrorForField(answer.id, 'transit_time')" 
                            :state="!hasValidationErrorForField(answer.id, 'transit_time')" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.transit_time"
                              type="text"
                              placeholder="7 дней"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Дата до которой действительна ставка *" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.validity_date"
                              type="date"
                              :min="new Date().toISOString().split('T')[0]"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="Минимальная рекомендованная маржинальность (%) *" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.recommended_margin"
                              @input="normalizeDecimalInput($event, 'recommended_margin', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="15.00"
                              size="sm"
                              style="max-width: 210px;"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>


                      <!-- Новые поля после transit_time -->
                      <b-row class="no-gutters align-items-end">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Оформление экс1" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.customs_clearance_ex1"
                              @input="normalizeDecimalInput($event, 'customs_clearance_ex1', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта экс1"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.customs_clearance_ex1_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по оформлению экс1 (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.customs_clearance_ex1_vat_rate"
                              @input="normalizeDecimalInput($event, 'customs_clearance_ex1_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="no-gutters align-items-end">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Экспортная лицензия" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.export_license"
                              @input="normalizeDecimalInput($event, 'export_license', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта лицензии"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.export_license_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по экспортной лицензии (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.export_license_vat_rate"
                              @input="normalizeDecimalInput($event, 'export_license_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <!-- Экспедирование в аэропорту (AVIA) -->
                      <b-row class="no-gutters align-items-end" v-if="shouldShowAirportForwarding(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Экспедирование в аэропорту" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.airport_forwarding_cost"
                              @input="normalizeDecimalInput($event, 'airport_forwarding_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта экспедирования в аэропорту"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.airport_forwarding_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по экспедированию в аэропорту (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.airport_forwarding_vat_rate"
                              @input="normalizeDecimalInput($event, 'airport_forwarding_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <!-- Терминальные расходы (RAIL) -->
                      <b-row class="no-gutters align-items-end" v-if="shouldShowTerminalExpenses(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Терминальные расходы" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.terminal_expenses_cost"
                              @input="normalizeDecimalInput($event, 'terminal_expenses_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта терминальных расходов"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.terminal_expenses_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по терминальным расходам (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.terminal_expenses_vat_rate"
                              @input="normalizeDecimalInput($event, 'terminal_expenses_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <!-- ЖД-доставка (MULTIMODAL) -->
                      <b-row class="no-gutters align-items-end" v-if="shouldShowRailDelivery(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="ЖД-доставка" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.rail_delivery_cost"
                              @input="normalizeDecimalInput($event, 'rail_delivery_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта ЖД-доставки"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.rail_delivery_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по ЖД-доставке (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.rail_delivery_vat_rate"
                              @input="normalizeDecimalInput($event, 'rail_delivery_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <!-- Терминальные расходы в порту прибытия (MULTIMODAL) -->
                      <b-row class="no-gutters align-items-end" v-if="shouldShowPortTerminalExpenses(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Терминальные расходы в порту прибытия" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.port_terminal_expenses_cost"
                              @input="normalizeDecimalInput($event, 'port_terminal_expenses_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта терминальных расходов в порту"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.port_terminal_expenses_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по терминальным расходам в порту (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.port_terminal_expenses_vat_rate"
                              @input="normalizeDecimalInput($event, 'port_terminal_expenses_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <!-- Услуги СВХ (AUTO) -->
                      <b-row class="no-gutters align-items-end" v-if="shouldShowWarehouseServices(answer)">
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Услуги СВХ" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.warehouse_services_cost"
                              @input="normalizeDecimalInput($event, 'warehouse_services_cost', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4" class="pr-1">
                          <b-form-group 
                            label="Валюта услуг СВХ"
                            label-class="form-label-sm"
                          >
                            <b-form-select
                              v-model="answer.warehouse_services_currency"
                              :options="currencyOptions"
                              size="sm"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group 
                            label="НДС по услугам СВХ (%)" 
                            label-class="form-label-sm"
                          >
                            <b-form-input
                              v-model="answer.warehouse_services_vat_rate"
                              @input="normalizeDecimalInput($event, 'warehouse_services_vat_rate', answer)"
                              type="number"
                              step="0.01"
                              min="0"
                              max="100"
                              placeholder="0.00"
                              size="sm"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-form-group 
                        label="Маршрут" 
                        label-class="form-label-sm"
                      >
                        <b-form-textarea
                          v-model="answer.route_description"
                          rows="2"
                          placeholder="Маршрут перевозки"
                          size="sm"
                          :disabled="loading"
                        ></b-form-textarea>
                      </b-form-group>

                      <b-form-group 
                        label="В ставку включено" 
                        label-class="form-label-sm"
                      >
                        <b-form-textarea
                          v-model="answer.included_in_rate"
                          rows="2"
                          placeholder="Укажите, что включено в ставку"
                          size="sm"
                          :disabled="loading"
                        ></b-form-textarea>
                      </b-form-group>

                      <b-form-group 
                        label="Комментарий логиста для КП" 
                        label-class="form-label-sm"
                      >
                        <b-form-textarea
                          v-model="answer.logistics_comment"
                          rows="2"
                          placeholder="Комментарий для КП"
                          size="sm"
                          :disabled="loading"
                        ></b-form-textarea>
                      </b-form-group>

                      <b-form-group 
                        label="Комментарий (служебный)" 
                        label-class="form-label-sm"
                      >
                        <b-form-textarea
                          v-model="answer.comment"
                          rows="2"
                          placeholder="Дополнительная информация..."
                          size="sm"
                          :disabled="loading"
                        ></b-form-textarea>
                      </b-form-group>

                      <div class="form-actions text-right mt-2">
                        <b-button
                          variant="primary"
                          size="sm"
                          @click="saveAnswer(answer.id)"
                          :disabled="isAnswerSaving(answer.id)"
                        >
                          <b-spinner small v-if="isAnswerSaving(answer.id)"></b-spinner>
                          <i v-else class="fas fa-save mr-1"></i>
                          Сохранить
                        </b-button>
                      
                        <b-button
                          variant="success"
                          size="sm"
                          class="ml-1"
                          :disabled="isAnswerLoading(answer.id) || !isAnswerValidForSend(answer)"
                          @click="saveAndSendAnswer(answer.id)"
                        >
                          <b-spinner small v-if="isAnswerLoading(answer.id)"></b-spinner>
                          <i v-else class="fas fa-paper-plane mr-1"></i>
                          Прокотировать
                        </b-button>
                        
                        <div class="mt-2">
                          <small class="text-muted font-italic fs10px">
                            * Поля со звездочкой обязательны для котирования
                          </small>
                        </div>
                      </div>
                    </b-form>
                  </div>
                </div>

                <!-- Карточка с информацией для статусов sent и selected -->
                <div v-else-if="showDataOnly || answer.status === 'sent' || answer.status === 'selected'">
                  <div class="answer-info border-top pt-3">
                    <div v-if="answer.user" class="mb-2 lh14px">
                      <small class="text-muted">Логист: {{ answer.user.name }}<br />
                      Последнее сохранение: {{ answer.updated_at }}</small>
                    </div>

                    <div class="row">
                      <div class="col-md-12 lh14px">
                        <strong>Стоимость доставки:</strong> 
                        <span v-if="answer.discount_rate && answer.discount_rate > 0" class="text-muted" style="text-decoration: line-through;">
                          {{ formatCostWithVat(answer.delivery_cost, answer.currency_id, answer.vat_rate, '—') }}
                        </span>
                        <span v-else>
                          {{ formatCostWithVat(answer.delivery_cost, answer.currency_id, answer.vat_rate, '—') }}
                        </span>
                        <span v-if="answer.discount_rate && answer.discount_rate > 0" class="text-success font-weight-bold ml-2">
                          {{ formatCostWithVat(calculateDiscountedCost(answer.delivery_cost, answer.discount_rate), answer.currency_id, answer.vat_rate, '—') }}
                        </span>
                      </div>
                      <div class="col-md-12 lh14px" v-if="answer.discount_rate" :class="{ 'text-success font-weight-bold': answer.discount_rate > 0 }">
                        <strong>Скидка:</strong> {{ formatCurrency(answer.discount_rate, answer.currency_id) }}
                      </div>
                      <div class="col-md-12 lh14px">
                        <strong>Транзитный срок:</strong> {{ answer.transit_time }} дней
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-md-12 lh14px" v-if="shouldShowSenderPickup(answer)">
                        <strong>Автовывоз со склада отправителя:</strong> {{ formatCostWithVat(answer.pickup_sender_cost, answer.pickup_sender_currency, answer.pickup_sender_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px">
                        <strong>Автовывоз до склада клиента:</strong> {{ formatCostWithVat(answer.auto_pickup_cost, answer.auto_pickup_currency, answer.auto_pickup_vat_rate, 'Не требуется') }}
                      </div>
                    </div>
                    
                    <!-- Новые поля -->
                    <div class="row mt-2">
                      <div class="col-md-12 lh14px">
                        <strong>Оформление экс1:</strong> {{ formatCostWithVat(answer.customs_clearance_ex1, answer.customs_clearance_ex1_currency, answer.customs_clearance_ex1_vat_rate, 'Оплачивается отдельно, расчет во время перевозки') }}
                      </div>
                      <div class="col-md-12 lh14px">
                        <strong>Экспортная лицензия:</strong> {{ formatCostWithVat(answer.export_license, answer.export_license_currency, answer.export_license_vat_rate, 'Оплачивается отдельно, расчет во время перевозки') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="shouldShowAirportForwarding(answer)">
                        <strong>Экспедирование в аэропорту:</strong> {{ formatCostWithVat(answer.airport_forwarding_cost, answer.airport_forwarding_currency, answer.airport_forwarding_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="shouldShowTerminalExpenses(answer)">
                        <strong>Терминальные расходы:</strong> {{ formatCostWithVat(answer.terminal_expenses_cost, answer.terminal_expenses_currency, answer.terminal_expenses_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="shouldShowRailDelivery(answer)">
                        <strong>ЖД-доставка:</strong> {{ formatCostWithVat(answer.rail_delivery_cost, answer.rail_delivery_currency, answer.rail_delivery_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="shouldShowPortTerminalExpenses(answer)">
                        <strong>Терминальные расходы в порту прибытия:</strong> {{ formatCostWithVat(answer.port_terminal_expenses_cost, answer.port_terminal_expenses_currency, answer.port_terminal_expenses_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="shouldShowWarehouseServices(answer)">
                        <strong>Услуги СВХ:</strong> {{ formatCostWithVat(answer.warehouse_services_cost, answer.warehouse_services_currency, answer.warehouse_services_vat_rate, 'Не требуется') }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="answer.insurance_rate">
                        <strong>Страховка:</strong> {{ answer.insurance_rate }}% от инвойсовой стоимости груза
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-md-12 lh14px">
                        <strong>Тип конвертации:</strong> {{ getConversionTypeText(answer.conversion_type) }}
                      </div>
                      <div class="col-md-12 lh14px" v-if="answer.conversion_rate">
                        <strong>Курс конвертации:</strong> {{ answer.conversion_rate }}
                      </div>
                    </div>

                    <div class="row mt-2">
                      <div class="col-md-12 lh14px" v-if="answer.recommended_margin">
                        <strong>Минимальная<br>рекомендованная<br>маржинальность:</strong> {{ answer.recommended_margin }}%
                      </div>
                      <div class="col-md-12 lh14px">
                        <strong>Валидность ставки до:</strong> {{ answer.validity_date | formattedDate }}
                      </div>
                    </div>

                    <div class="mt-2 lh14px" v-if="answer.route_description">
                      <strong>Маршрут:</strong> {{ answer.route_description }}
                    </div>
                    <div class="mt-2 lh14px" v-if="answer.included_in_rate">
                      <strong>В ставку включено:</strong> {{ answer.included_in_rate }}
                    </div>
                    <div class="mt-2 lh14px" v-if="answer.logistics_comment">
                      <strong>Комментарий логиста для КП:</strong> {{ answer.logistics_comment }}
                    </div>
                    <div class="mt-2 lh14px">
                      <strong>Комментарий (служебный):</strong> {{ answer.comment || 'Не указан' }}
                    </div>

                    <div class="mt-2" v-if="!showDataOnly && canEditDiscount">
                       <div class="row">
                         <div class="col-md-12 d-flex justify-content-start align-items-end">
                           <b-form-group 
                             label="Скидка (сумма в валюте доставки)" 
                             label-class="form-label-sm"
                             class="mb-0 mr-1"
                           >
                             <b-form-input
                               v-model="answer.discount_rate"
                               @input="normalizeDecimalInput($event, 'discount_rate', answer)"
                               type="number"
                               step="0.01"
                               min="0"
                               placeholder="0.00"
                               size="sm"
                               style="width: 160px;"
                             ></b-form-input>
                           </b-form-group>
                           <button
                             type="button"
                             class="btn btn-outline-secondary btn-sm btn28-uppercase ml-2"
                             style="height: 33.2px;"
                             @click="saveDiscount(answer.id)"
                             :disabled="savingDiscount[answer.id] || !answer.discount_rate || answer.discount_rate <= 0"
                           >
                             <i class="fas fa-spinner fa-spin" v-if="savingDiscount[answer.id]"></i>
                             <i v-else class="fas fa-save"></i>
                           </button>
                         </div>
                       </div>
                     </div>

                    <!-- Поле для ставки клиента - показывается только для прокотированных ответов и разрешенных ролей -->
                    <div 
                      v-if="((answer.status === 'sent' || answer.status === 'selected') && canSeeClientRate) || (showDataOnly && canSeeClientRate)"
                      class="quotation-bill mt-3 p-3 bg-light border-left border-primary"
                      :class="showDataOnly ? 'quotation-bill-short' : 'quotation-bill'"
                    >
                      <h6 class="text-primary mb-3">Ставка для клиента</h6>
                      
                      <!-- Если ставка уже сохранена -->
                      <div 
                        v-if="hasSavedClientRates(answer)" 
                        class="mb-3"
                        style="flex: auto; margin-bottom: 10px; font-size: 11px;"
                      >
                        <div class="row">
                          <template v-for="field in clientRateFieldsConfig">
                            <div
                              class="col-md-6 lh16px"
                              v-if="answer[field.key]"
                              :key="`saved-${field.key}`"
                            >
                              <strong>{{ field.label }}:</strong> {{ formatCurrency(answer[field.key], getClientRateFieldCurrency(answer, field)) }}
                            </div>
                          </template>
                          <div class="col-md-12 mt-2" v-if="answer.client_rate_manager">
                            <small class="text-muted lh14px">
                              {{ answer.client_rate_manager.name }} / {{ answer.client_rate_saved_at | formattedDateTime }}
                            </small>
                          </div>
                        </div>
                      </div>

                      <!-- Если ставка не была указана (в режиме просмотра) -->
                      <div 
                        v-else-if="showDataOnly"
                        class="mb-3"
                        style="flex: auto; margin-bottom: 10px; font-size: 11px;"
                      >
                        <div class="row">
                          <div class="col-md-12 lh16px">
                            <span class="text-muted">Отсутствует</span>
                          </div>
                        </div>
                      </div>

                      <!-- Поле для ввода/редактирования ставки клиента -->
                       <div v-if="!showDataOnly && clientRateForms[answer.id]" style="flex: auto;">
                        <div class="row">
                          <div v-for="field in getClientRateFields(answer)" :key="`field-${field.key}`" class="col-md-12 d-flex mb-2">
                            <div class="col-md-7 pl-0">
                              <b-form-group 
                                :label="field.label" 
                                label-class="form-label-sm"
                                class="mb-0"
                              >
                                <b-form-input
                                  v-model="clientRateForms[answer.id][field.key]"
                                  type="number"
                                  step="0.01"
                                  min="0"
                                  :placeholder="answer[field.key] || 'Введите ставку'"
                                  :disabled="answer.status === 'selected'"
                                  size="sm"
                                ></b-form-input>
                              </b-form-group>
                            </div>
                            <div class="col-md-5 d-flex align-items-end" v-if="field.costField && answer[field.costField]">
                              <div class="w-100 lh14px pb-2 mb-1">
                                <small class="text-muted d-block">Маржинальность:</small>
                                <span class="font-weight-bold" :class="getMarginColor(answer[field.costField], clientRateForms[answer.id][field.key])">
                                  {{ calculateMargin(answer[field.costField], clientRateForms[answer.id][field.key]) }}%
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                       <div class="row mt-2" v-if="!showDataOnly && answer.order && answer.order.reference_order_type_id == 1 && getClientRateFields(answer).length > 0">
                        <div class="col-md-12 text-center">
                            <button
                              type="button"
                              class="btn btn-outline-primary btn-sm"
                              @click="saveAllClientRates(answer.id)"
                              :disabled="savingClientRate[answer.id] || savingClientRateForPickup[answer.id] || answer.status === 'selected' || !hasClientRateInput(answer.id, answer)"
                            >
                              <i class="fas fa-spinner fa-spin" v-if="savingClientRate[answer.id] || savingClientRateForPickup[answer.id]"></i>
                              <i v-else class="fas fa-save"></i>
                              Сохранить ставки
                            </button>
                        </div>
                       </div>
                      <div class="row mt-3" v-if="answer.client_rate > 0">
                        <div class="col-md-12 d-flex justify-content-between align-items-center">
                          <button
                            type="button"
                            class="btn btn-outline-primary btn-sm"
                            @click="exportQuotation(answer.id)"
                            :disabled="!answer.client_rate"
                            style="width: 160px;"
                          >
                            <i class="fas fa-download mr-1"></i>
                            Выгрузить КП
                          </button>

                          <button
                            v-if="!showDataOnly"
                            type="button"
                            class="btn btn-success btn-sm btn28-uppercase"
                            @click="selectedQuotation(answer.id)"
                            :disabled="!answer.client_rate || answer.status === 'selected' || isAnswerLoading(answer.id)"
                            style="width: 160px;"
                            :title="answer.status === 'selected' ? 'Ставка утверждена' : 'После утверждения, ставку уже нельзя будет редактировать'"
                          >
                            <i class="fas fa-spinner fa-spin mr-1" v-if="isAnswerLoading(answer.id)"></i>
                            <i v-else class="fas fa-check mr-1"></i>
                            {{ answer.status === 'selected' ? 'Ставка утверждена' : 'Утвердить ставку' }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { 
  API_ORDER_SERVICES_QUOTATION_ANSWERS
} from '@/constants';

const TRANSPORT_GROUPS = Object.freeze({
  AVIA: [998],
  RAIL: [996, 997],
  MULTIMODAL: [994, 995],
  AUTO: [992, 993]
});

const CLIENT_RATE_FIELDS = Object.freeze([
  {
    key: 'client_rate',
    label: 'Ставка для клиента (доставка)',
    groups: ['AVIA', 'RAIL', 'MULTIMODAL', 'AUTO'],
    currencyField: 'currency_id',
    costField: 'delivery_cost',
    requiresCostField: false
  },
  {
    key: 'client_rate_for_sender_pickup',
    label: 'Ставка для клиента (автовывоз со склада отправителя)',
    groups: ['AVIA', 'RAIL', 'MULTIMODAL', 'AUTO'],
    currencyField: 'pickup_sender_currency',
    costField: 'pickup_sender_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_pickup',
    label: 'Ставка для клиента (автовывоз до склада клиента)',
    groups: ['AVIA', 'RAIL', 'MULTIMODAL', 'AUTO'],
    currencyField: 'auto_pickup_currency',
    costField: 'auto_pickup_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_airport_forwarding',
    label: 'Ставка для клиента (экспедирование в аэропорту)',
    groups: ['AVIA'],
    currencyField: 'airport_forwarding_currency',
    costField: 'airport_forwarding_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_terminal_expenses',
    label: 'Ставка для клиента (терминальные расходы)',
    groups: ['RAIL'],
    currencyField: 'terminal_expenses_currency',
    costField: 'terminal_expenses_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_rail_delivery',
    label: 'Ставка для клиента (ЖД-доставка)',
    groups: ['MULTIMODAL'],
    currencyField: 'rail_delivery_currency',
    costField: 'rail_delivery_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_port_terminal_expenses',
    label: 'Ставка для клиента (терминальные расходы в порту прибытия)',
    groups: ['MULTIMODAL'],
    currencyField: 'port_terminal_expenses_currency',
    costField: 'port_terminal_expenses_cost',
    requiresCostField: true
  },
  {
    key: 'client_rate_for_warehouse_services',
    label: 'Ставка для клиента (услуги СВХ)',
    groups: ['AUTO'],
    currencyField: 'warehouse_services_currency',
    costField: 'warehouse_services_cost',
    requiresCostField: true
  }
]);

export default {
  name: 'OrderServiceQuotationAnswerForms',
  props: {
    orderId: { type: [Number, String], required: true },
    orderServiceId: { type: [Number, String], required: true },
    selectedTransportTypes: { type: Array, required: true },
    orderServiceQuotationId: { type: [Number, String], required: true },
    orderReferenceStatusId: { type: [Number, String], default: null },
    showDataOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      answers: [],
      editingAnswerId: null,
      loadingAnswers: {}, // { answerId: true/false } для кнопки "Прокотировать"
      savingAnswers: {}, // { answerId: true/false } для кнопки "Сохранить"
      clientRateForms: {}, // { answerId: { client_rate, client_rate_for_pickup, ... } }
      clientRateFieldsConfig: CLIENT_RATE_FIELDS,
      savingClientRate: {}, // { answerId: true/false } для кнопки "Сохранить ставку"
      savingClientRateForPickup: {}, // { answerId: true/false } для кнопки "Сохранить ставку по автовывозу"
      savingDiscount: {}, // { answerId: true/false } для кнопки "Сохранить скидку"
      answerForm: {
        delivery_cost: '',
        currency_id: null,
        auto_pickup_cost: '',
        auto_pickup_currency: null,
        auto_pickup_vat_rate: '',
        pickup_sender_cost: '',
        pickup_sender_currency: null,
        pickup_sender_vat_rate: '',
        transit_time: '',
        customs_clearance_ex1: '',
        customs_clearance_ex1_currency: null,
        customs_clearance_ex1_vat_rate: '',
        export_license: '',
        export_license_currency: null,
        export_license_vat_rate: '',
        airport_forwarding_cost: '',
        airport_forwarding_currency: null,
        airport_forwarding_vat_rate: '',
        terminal_expenses_cost: '',
        terminal_expenses_currency: null,
        terminal_expenses_vat_rate: '',
        rail_delivery_cost: '',
        rail_delivery_currency: null,
        rail_delivery_vat_rate: '',
        port_terminal_expenses_cost: '',
        port_terminal_expenses_currency: null,
        port_terminal_expenses_vat_rate: '',
        warehouse_services_cost: '',
        warehouse_services_currency: null,
        warehouse_services_vat_rate: '',
        conversion_rate: '',
        conversion_type: 'cb_rate',
        vat_rate: 20.00,
        recommended_margin: 15.00,
        validity_date: '',
        comment: '',
        route_description: '',
        included_in_rate: '',
        logistics_comment: '',
        insurance_rate: 0.16,
        discount_rate: ''
      },
              validationErrors: {}, // { answerId: { field: 'error message' } }
      conversionTypeOptions: [
        { value: 'cb_rate', text: 'Ставка ЦБ' },
        { value: 'cb_plus_percent', text: 'ЦБ + процент' }
      ],
      currencyOptions: [
        { value: null, text: 'Валюта...' },
        { value: 'USD', text: 'USD' },
        { value: 'EUR', text: 'EUR' },
        { value: 'CNY', text: 'CNY' },
        { value: 'TRY', text: 'TRY' },
        { value: 'AMD', text: 'AMD' },
        { value: 'AED', text: 'AED' },
        { value: 'RUB', text: 'RUB' }
      ]
    }
  },
  computed: {
    ...mapGetters(['referenceProperties']),
    ...mapGetters("auth", ["currentUser"]),

    isAgent() {
      return this.currentUser.role.includes('agent');
    },

    isLogisticsManager() {
      return this.currentUser.role.includes('logistics-manager') || 
             this.currentUser.role.includes('logistics-head-manager') || 
             this.currentUser.role.includes('logistics-multim-manager') || 
             this.currentUser.role.includes('logistics-multim-head-manager');
    },
    
    canSeeClientRate() {
      // Роли, которые НЕ могут видеть/редактировать ставку клиента и утверждать котировку
      // logistics-head-manager может (наравне с менеджером, агентом, администратором)
      const restrictedRoles = [
        'logistics-manager',
        'logistics-multim-head-manager',
        'logistics-multim-manager'
      ];
      
      return !restrictedRoles.some(role => this.currentUser.role.includes(role));
    },

    canEditDiscount() {
      // Роли, которые НЕ могут редактировать скидку
      const restrictedRoles = [
        'client',
        'agent'
      ];
      
      return !restrictedRoles.some(role => this.currentUser.role.includes(role));
    }
  },
  mounted() {
    this.loadAnswers();
  },
  methods: {
    async loadAnswers() {
      if (!this.orderServiceQuotationId) {
        return;
      }
      
      try {
        this.loading = true;

        const params = {
          order_id: this.orderId,
          order_service_id: this.orderServiceId,
          order_service_quotation_id: this.orderServiceQuotationId
        };

        const response = await api.call('get', API_ORDER_SERVICES_QUOTATION_ANSWERS, { params });
        
        if (response.data.success) {
          this.answers = response.data.answers;
          
          // Если нет ответов (даже заготовок), значит это старый формат котировок
          if (this.answers.length === 0) {
            console.log('Нет заготовок ответов - старый формат котировок');
            return;
          }

          // Инициализируем форму базовыми значениями из первого шаблона
          this.initializeFormWithTemplate();

          // Инициализируем формы ставки клиента для разрешенных ролей
          if (this.canSeeClientRate) {
            this.clientRateForms = {};
            this.answers.forEach(answer => {
              this.$set(this.clientRateForms, answer.id, this.buildClientRateForm(answer));
            });
          }
        }
      } catch (error) {
        console.error('Ошибка загрузки ответов:', error);
        this.$bvToast.toast('Ошибка загрузки ответов на котировку', {
          title: 'Ошибка',
          variant: 'danger'
        });
      } finally {
        this.loading = false;
      }
    },

    getTransportTypeName(transportTypeId) {
      return this.$store.state.referencePropertiesList.list[transportTypeId] ? this.$store.state.referencePropertiesList.list[transportTypeId].text : `Тип перевозки ${transportTypeId}`;
    },

    getTransportGroupKey(transportTypeId) {
      const type = Number(transportTypeId);
      if (TRANSPORT_GROUPS.AVIA.includes(type)) return 'AVIA';
      if (TRANSPORT_GROUPS.RAIL.includes(type)) return 'RAIL';
      if (TRANSPORT_GROUPS.MULTIMODAL.includes(type)) return 'MULTIMODAL';
      if (TRANSPORT_GROUPS.AUTO.includes(type)) return 'AUTO';
      return 'OTHER';
    },

    isTransportGroup(answer, groups) {
      const groupKey = this.getTransportGroupKey(answer.transport_types_id);
      const allowedGroups = Array.isArray(groups) ? groups : [groups];
      return allowedGroups.includes(groupKey);
    },

    shouldShowSenderPickup(answer) {
      return this.isTransportGroup(answer, ['AVIA', 'RAIL', 'MULTIMODAL', 'AUTO']);
    },

    shouldShowAirportForwarding(answer) {
      return this.isTransportGroup(answer, 'AVIA');
    },

    shouldShowTerminalExpenses(answer) {
      return this.isTransportGroup(answer, 'RAIL');
    },

    shouldShowRailDelivery(answer) {
      return this.isTransportGroup(answer, 'MULTIMODAL');
    },

    shouldShowPortTerminalExpenses(answer) {
      return this.isTransportGroup(answer, 'MULTIMODAL');
    },

    shouldShowWarehouseServices(answer) {
      return this.isTransportGroup(answer, 'AUTO');
    },

    buildClientRateForm(answer = {}) {
      const form = {};
      this.clientRateFieldsConfig.forEach(field => {
        const hasValue = Object.prototype.hasOwnProperty.call(answer, field.key) && answer[field.key] !== null && answer[field.key] !== undefined;
        form[field.key] = hasValue ? answer[field.key] : '';
      });
      return form;
    },

    getClientRateForm(answerId) {
      if (!this.clientRateForms[answerId]) {
        this.$set(this.clientRateForms, answerId, this.buildClientRateForm());
      }
      return this.clientRateForms[answerId];
    },

    getClientRateFields(answer) {
      const groupKey = this.getTransportGroupKey(answer.transport_types_id);
      return this.clientRateFieldsConfig.filter(field => field.groups.includes(groupKey))
        .filter(field => {
          if (!field.requiresCostField) {
            return true;
          }
          const value = answer[field.costField];
          return value !== null && value !== undefined && value !== '' && Number(value) > 0;
        });
    },

    getClientRateFieldCurrency(answer, field) {
      if (field.currencyField && answer[field.currencyField]) {
        return answer[field.currencyField];
      }
      return answer.currency_id;
    },

    hasClientRateInput(answerId, answer) {
      const form = this.getClientRateForm(answerId);
      const applicableFields = this.getClientRateFields(answer);
      return applicableFields.some(field => {
        const value = form[field.key];
        return value !== null && value !== undefined && value !== '' && Number(value) > 0;
      });
    },

    hasSavedClientRates(answer) {
      return this.clientRateFieldsConfig.some(field => {
        const value = answer[field.key];
        return value !== null && value !== undefined && value !== '' && Number(value) > 0;
      });
    },

    isAnswerValid(answer) {
      if (!answer.id) return false;
      
      const hasRequiredFields = answer.delivery_cost && 
                                answer.currency_id && 
                                answer.transit_time &&
                                answer.conversion_type;
      
      const hasValidationErrors = this.validationErrors[answer.id] && 
                                  Object.keys(this.validationErrors[answer.id]).length > 0;
      
      return hasRequiredFields && !hasValidationErrors;
    },

    isAnswerValidForSend(answer) {
      if (!answer.id) return false;
      
      // Все основные поля обязательны для отправки (кроме комментария)
      // Курс конвертации обязателен только если выбран тип "ЦБ + процент"
      const hasAllRequiredFields = answer.delivery_cost && 
                                   answer.currency_id && 
                                   answer.transit_time &&
                                   (answer.conversion_type !== 'cb_plus_percent' || answer.conversion_rate) &&
                                   answer.conversion_type &&
                                   answer.vat_rate &&
                                   answer.recommended_margin &&
                                   answer.validity_date;
      
      const hasValidationErrors = this.validationErrors[answer.id] && 
                                  Object.keys(this.validationErrors[answer.id]).length > 0;
      
      return hasAllRequiredFields && !hasValidationErrors;
    },

    getValidationErrorsForAnswer(answerId) {
      return this.validationErrors[answerId] || {};
    },

    getValidationErrorForField(answerId, field) {
      const errors = this.getValidationErrorsForAnswer(answerId);
      return errors[field] || null;
    },

    hasValidationErrorForField(answerId, field) {
      return !!this.getValidationErrorForField(answerId, field);
    },

    shouldShowFormForTransportType(transportTypeId) {
      // Больше не используется, так как формы отображаются всегда для статуса filling
      return true;
    },

    editAnswer(answer) {
      this.editingAnswerId = answer.id;
      this.fillFormWithAnswer(answer);
    },

    fillFormWithAnswer(answer) {
      this.answerForm = {
        delivery_cost: answer.delivery_cost,
        currency_id: answer.currency_id,
        auto_pickup_cost: answer.auto_pickup_cost,
        auto_pickup_currency: answer.auto_pickup_currency,
        auto_pickup_vat_rate: answer.auto_pickup_vat_rate,
        pickup_sender_cost: answer.pickup_sender_cost,
        pickup_sender_currency: answer.pickup_sender_currency,
        pickup_sender_vat_rate: answer.pickup_sender_vat_rate,
        transit_time: answer.transit_time,
        customs_clearance_ex1: answer.customs_clearance_ex1,
        customs_clearance_ex1_currency: answer.customs_clearance_ex1_currency,
        customs_clearance_ex1_vat_rate: answer.customs_clearance_ex1_vat_rate,
        export_license: answer.export_license,
        export_license_currency: answer.export_license_currency,
        export_license_vat_rate: answer.export_license_vat_rate,
        airport_forwarding_cost: answer.airport_forwarding_cost,
        airport_forwarding_currency: answer.airport_forwarding_currency,
        airport_forwarding_vat_rate: answer.airport_forwarding_vat_rate,
        terminal_expenses_cost: answer.terminal_expenses_cost,
        terminal_expenses_currency: answer.terminal_expenses_currency,
        terminal_expenses_vat_rate: answer.terminal_expenses_vat_rate,
        rail_delivery_cost: answer.rail_delivery_cost,
        rail_delivery_currency: answer.rail_delivery_currency,
        rail_delivery_vat_rate: answer.rail_delivery_vat_rate,
        port_terminal_expenses_cost: answer.port_terminal_expenses_cost,
        port_terminal_expenses_currency: answer.port_terminal_expenses_currency,
        port_terminal_expenses_vat_rate: answer.port_terminal_expenses_vat_rate,
        warehouse_services_cost: answer.warehouse_services_cost,
        warehouse_services_currency: answer.warehouse_services_currency,
        warehouse_services_vat_rate: answer.warehouse_services_vat_rate,
        conversion_rate: answer.conversion_rate,
        conversion_type: answer.conversion_type,
        vat_rate: answer.vat_rate,
        recommended_margin: answer.recommended_margin,
        validity_date: answer.validity_date,
        comment: answer.comment,
        route_description: answer.route_description,
        included_in_rate: answer.included_in_rate,
        logistics_comment: answer.logistics_comment,
        insurance_rate: answer.insurance_rate || 0.16,
        discount_rate: answer.discount_rate
      };
    },

    resetForm() {
      this.answerForm = {
        delivery_cost: '',
        currency_id: null,
        auto_pickup_cost: '',
        auto_pickup_currency: 'RUB',
        auto_pickup_vat_rate: '',
        pickup_sender_cost: '',
        pickup_sender_currency: null,
        pickup_sender_vat_rate: '',
        transit_time: '',
        customs_clearance_ex1: '',
        customs_clearance_ex1_currency: null,
        customs_clearance_ex1_vat_rate: '',
        export_license: '',
        export_license_currency: null,
        export_license_vat_rate: '',
        airport_forwarding_cost: '',
        airport_forwarding_currency: null,
        airport_forwarding_vat_rate: '',
        terminal_expenses_cost: '',
        terminal_expenses_currency: null,
        terminal_expenses_vat_rate: '',
        rail_delivery_cost: '',
        rail_delivery_currency: null,
        rail_delivery_vat_rate: '',
        port_terminal_expenses_cost: '',
        port_terminal_expenses_currency: null,
        port_terminal_expenses_vat_rate: '',
        warehouse_services_cost: '',
        warehouse_services_currency: null,
        warehouse_services_vat_rate: '',
        conversion_rate: '',
        conversion_type: 'cb_rate',
        vat_rate: 20.00,
        recommended_margin: 15.00,
        validity_date: '',
        comment: '',
        route_description: '',
        included_in_rate: '',
        logistics_comment: '',
        insurance_rate: 0.16,
        discount_rate: ''
      };
    },

    clearValidationErrorsForAnswer(answerId) {
      this.$set(this.validationErrors, answerId, {});
    },

    setAnswerLoading(answerId, loading) {
      this.$set(this.loadingAnswers, answerId, loading);
    },

    isAnswerLoading(answerId) {
      return this.loadingAnswers[answerId] || false;
    },

    setAnswerSaving(answerId, saving) {
      this.$set(this.savingAnswers, answerId, saving);
    },

    isAnswerSaving(answerId) {
      return this.savingAnswers[answerId] || false;
    },

    normalizeDecimalInput(value, field, answer) {
      if (typeof value === 'string' && value !== '') {
        // Заменяем все запятые на точки
        let normalizedValue = value.replace(/,/g, '.');
        
        // Убираем лишние точки, оставляем только первую
        const parts = normalizedValue.split('.');
        if (parts.length > 2) {
          normalizedValue = parts[0] + '.' + parts.slice(1).join('');
        }
        
        // Обновляем значение в объекте answer
        this.$set(answer, field, normalizedValue);
        return normalizedValue;
      }
      return value;
    },

    cancelEdit() {
      if (this.editingAnswerId) {
        this.clearValidationErrorsForAnswer(this.editingAnswerId);
      }
      this.editingAnswerId = null;
      this.resetForm();
    },

    async saveAnswer(answerId) {
      await this._saveAnswer(answerId, false);
    },

    async saveAndSendAnswer(answerId) {
      await this._saveAnswer(answerId, true);
    },

    async _saveAnswer(answerId, shouldSend = false) {
      try {
        // Устанавливаем правильный лоадер в зависимости от операции
        if (shouldSend) {
          this.setAnswerLoading(answerId, true);
        } else {
          this.setAnswerSaving(answerId, true);
        }
        
        // Очищаем ошибки валидации для этого конкретного answer
        this.$set(this.validationErrors, answerId, {});

        const answer = this.answers.find(a => a.id === answerId);
        if (!answer) {
          console.error('Answer not found:', answerId);
          return;
        }

        const data = {
          id: answer.id,
          delivery_cost: answer.delivery_cost,
          currency_id: answer.currency_id,
          auto_pickup_cost: answer.auto_pickup_cost,
          auto_pickup_currency: answer.auto_pickup_currency,
          auto_pickup_vat_rate: answer.auto_pickup_vat_rate,
          pickup_sender_cost: answer.pickup_sender_cost,
          pickup_sender_currency: answer.pickup_sender_currency,
          pickup_sender_vat_rate: answer.pickup_sender_vat_rate,
          transit_time: answer.transit_time,
          customs_clearance_ex1: answer.customs_clearance_ex1,
          customs_clearance_ex1_currency: answer.customs_clearance_ex1_currency,
          customs_clearance_ex1_vat_rate: answer.customs_clearance_ex1_vat_rate,
          export_license: answer.export_license,
          export_license_currency: answer.export_license_currency,
          export_license_vat_rate: answer.export_license_vat_rate,
          airport_forwarding_cost: answer.airport_forwarding_cost,
          airport_forwarding_currency: answer.airport_forwarding_currency,
          airport_forwarding_vat_rate: answer.airport_forwarding_vat_rate,
          terminal_expenses_cost: answer.terminal_expenses_cost,
          terminal_expenses_currency: answer.terminal_expenses_currency,
          terminal_expenses_vat_rate: answer.terminal_expenses_vat_rate,
          rail_delivery_cost: answer.rail_delivery_cost,
          rail_delivery_currency: answer.rail_delivery_currency,
          rail_delivery_vat_rate: answer.rail_delivery_vat_rate,
          port_terminal_expenses_cost: answer.port_terminal_expenses_cost,
          port_terminal_expenses_currency: answer.port_terminal_expenses_currency,
          port_terminal_expenses_vat_rate: answer.port_terminal_expenses_vat_rate,
          warehouse_services_cost: answer.warehouse_services_cost,
          warehouse_services_currency: answer.warehouse_services_currency,
          warehouse_services_vat_rate: answer.warehouse_services_vat_rate,
          conversion_rate: answer.conversion_rate,
          conversion_type: answer.conversion_type,
          vat_rate: answer.vat_rate,
          recommended_margin: answer.recommended_margin,
          validity_date: answer.validity_date,
          comment: answer.comment,
          route_description: answer.route_description,
          included_in_rate: answer.included_in_rate,
          logistics_comment: answer.logistics_comment,
          insurance_rate: answer.insurance_rate,
          discount_rate: answer.discount_rate,
          order_id: this.orderId,
          order_service_id: this.orderServiceId,
          order_service_quotation_id: this.orderServiceQuotationId,
          transport_types_id: answer.transport_types_id
        };

        let response;
        response = await api.call('put', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answer.id}`, data);

        // if (this.editingAnswerId) {
        //   response = await api.call('put', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${this.editingAnswerId}`, data);
        // }
        //  else {
        //   response = await api.call('post', API_ORDER_SERVICES_QUOTATION_ANSWERS, data);
        // }

        if (response.data.success) {
          if (shouldSend && !this.editingAnswerId) {
            await this.sendAnswer(response.data.answer.id);
          } else {
            this.$bvToast.toast(response.data.message, {
              title: 'Успешно',
              variant: 'success'
            });
          }
          
          this.loadAnswers();
          
          if (this.editingAnswerId) {
            this.cancelEdit();
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          // Записываем ошибки валидации для конкретного answer
          this.$set(this.validationErrors, answerId, error.response.data.errors || {});
        }
        console.error('Ошибка сохранения ответа:', error);
        this.$bvToast.toast('Ошибка сохранения ответа', {
          title: 'Ошибка',
          variant: 'danger'
        });
              } finally {
          // Сбрасываем правильный лоадер
          if (shouldSend) {
            this.setAnswerLoading(answerId, false);
          } else {
            this.setAnswerSaving(answerId, false);
          }
        }
    },

    async sendAnswer(answerId) {
      try {
        this.setAnswerLoading(answerId, true);
        const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/send`);
        
        if (response.data.success) {
          this.$bvToast.toast(response.data.message, {
            title: 'Успешно',
            variant: 'success'
          });

          this.loadAnswers();

          if (response.data.orderStatusUpdated) {
            // Эмитим событие для обновления данных заказа
            this.$emit('orderUpdated', {
              orderId: this.orderId,
              message: 'Статус Заявки обновлен на «Котировка получена»'
            });              
          }
        }
      } catch (error) {
        console.error('Ошибка отправки ответа:', error);
        this.$bvToast.toast('Ошибка отправки ответа', {
          title: 'Ошибка',
          variant: 'danger'
        });
      } finally {
        this.setAnswerLoading(answerId, false);
      }
    },

    async selectAnswer(answerId) {
      try {
        this.setAnswerLoading(answerId, true);
        const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/select`);
        
        if (response.data.success) {
          this.$bvToast.toast(response.data.message, {
            title: 'Успешно',
            variant: 'success'
          });
          this.loadAnswers();
        }
      } catch (error) {
        console.error('Ошибка выбора ответа:', error);
        this.$bvToast.toast('Ошибка выбора ответа', {
          title: 'Ошибка',
          variant: 'danger'
        });
      } finally {
        this.setAnswerLoading(answerId, false);
      }
    },

    canEditAnswer(answer) {
      // Можно редактировать только свои ответы и только в статусе 'filling'
      // Заготовки редактировать нельзя, они превращаются в ответы через создание
      return answer.status === 'filling' && answer.user_id === this.$store.state.user.id;
    },

    getStatusText(status) {
      const statusMap = {
        'filling': 'На заполнении',
        'sent': 'Прокотирован',
        'selected': 'Выбран'
      };
      return statusMap[status] || status;
    },

    getStatusBadgeClass(status) {
      const classMap = {
        'filling': 'badge-secondary',
        'sent': 'badge-warning',
        'selected': 'badge-success'
      };
      return classMap[status] || 'badge-secondary';
    },

    getConversionTypeText(conversionType) {
      const typeMap = {
        'cb_rate': 'Ставка ЦБ',
        'cb_plus_percent': 'ЦБ + процент'
      };
      return typeMap[conversionType] || conversionType;
    },

    formatCurrency(amount, currency) {
      if (amount === null || amount === undefined || amount === '') {
        return '—';
      }

      const numericAmount = Number(amount);
      const formattedAmount = Number.isFinite(numericAmount)
        ? numericAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : amount;

      const currencyCode = currency || '';
      return currencyCode ? `${formattedAmount} ${currencyCode}` : formattedAmount;
    },

    formatCostWithVat(amount, currency, vatRate, emptyText = 'Не требуется') {
      if (amount === null || amount === undefined || amount === '') {
        return emptyText;
      }
      const base = this.formatCurrency(amount, currency);
      if (!vatRate && vatRate !== 0) {
        return base;
      }
      const numericVat = Number(vatRate);
      const vatValue = Number.isFinite(numericVat) ? numericVat : vatRate;
      return `${base} (НДС: ${vatValue}%)`;
    },

    initializeFormWithTemplate() {
      // Инициализируем форму базовыми значениями
      this.answerForm = {
        delivery_cost: '',
        currency_id: null,
        auto_pickup_cost: '',
        auto_pickup_currency: null,
        transit_time: '',
        customs_clearance_ex1: '',
        customs_clearance_ex1_currency: null,
        export_license: '',
        export_license_currency: null,
        conversion_rate: '',
        conversion_type: 'cb_rate',
        vat_rate: 20.00,
        recommended_margin: 15.00,
        validity_date: '',
        comment: '',
        insurance_rate: 0.16,
        discount_rate: ''
      };
    },

    async saveClientRate(answerId) {
      const form = this.getClientRateForm(answerId);
      const clientRate = form.client_rate;
      
      if (!clientRate || clientRate <= 0) {
        this.$bvToast.toast('Введите корректную ставку для клиента', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
        return;
      }

      this.$set(this.savingClientRate, answerId, true);

      try {
        const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/client-rate`, {
          client_rate: clientRate
        });

        if (response.data.success) {
          // Обновляем ответ в списке
          const answerIndex = this.answers.findIndex(a => a.id === answerId);
          if (answerIndex !== -1) {
            this.answers.splice(answerIndex, 1, response.data.answer);
          }
          this.$set(this.clientRateForms, answerId, this.buildClientRateForm(response.data.answer));

          this.$bvToast.toast(response.data.message, {
            title: 'Успех',
            variant: 'success',
            solid: true
          });
        }
      } catch (error) {
        let errorMessage = 'Произошла ошибка при сохранении ставки';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        this.$bvToast.toast(errorMessage, {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.$set(this.savingClientRate, answerId, false);
      }
    },

    async saveAllClientRates(answerId) {
      const answer = this.answers.find(a => a.id === answerId);
      if (!answer) {
        return;
      }

      const form = this.getClientRateForm(answerId);
      const applicableFields = this.getClientRateFields(answer);
      const payload = {};

      applicableFields.forEach(field => {
        const rawValue = form[field.key];
        if (rawValue !== null && rawValue !== undefined && rawValue !== '' && Number(rawValue) > 0) {
          payload[field.key] = rawValue;
        }
      });
      
      if (Object.keys(payload).length === 0) {
        this.$bvToast.toast('Введите хотя бы одну ставку для клиента', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
        return;
      }

      this.$set(this.savingClientRate, answerId, true);
      this.$set(this.savingClientRateForPickup, answerId, true);

      const updateAnswerInList = (updatedAnswer) => {
        if (!updatedAnswer) return;
        const answerIndex = this.answers.findIndex(a => a.id === answerId);
        if (answerIndex !== -1) {
          this.answers.splice(answerIndex, 1, updatedAnswer);
        }
        this.$set(this.clientRateForms, answerId, this.buildClientRateForm(updatedAnswer));
      };

      try {
        if (payload.client_rate) {
          const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/client-rate`, {
            client_rate: payload.client_rate
          });

          if (response.data.success) {
            updateAnswerInList(response.data.answer);
          }
        }

        const restPayload = { ...payload };
        delete restPayload.client_rate;

        if (Object.keys(restPayload).length > 0) {
          const response = await api.call('put', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}`, restPayload);

          if (response.data.success) {
            updateAnswerInList(response.data.answer);
          }
        }

        this.$bvToast.toast('Ставки для клиента успешно сохранены', {
          title: 'Успех',
          variant: 'success',
          solid: true
        });

      } catch (error) {
        let errorMessage = 'Произошла ошибка при сохранении ставок';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        this.$bvToast.toast(errorMessage, {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.$set(this.savingClientRate, answerId, false);
        this.$set(this.savingClientRateForPickup, answerId, false);
      }
    },

    async exportQuotation(answerId) {
      try {
        this.$bvToast.toast('Генерация КП...', {
          title: 'Информация',
          variant: 'info',
          solid: true
        });

        const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/export-quotation`);
        
        if (response.data.link) {
          // Открываем ссылку для скачивания в новой вкладке
          window.open(response.data.link, '_blank');
          
          this.$bvToast.toast('КП успешно сгенерирован', {
            title: 'Успешно',
            variant: 'success',
            solid: true
          });
        } else {
          throw new Error('Не получена ссылка на документ');
        }
      } catch (error) {
        let errorMessage = 'Ошибка при генерации КП';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        
        console.error('Ошибка экспорта КП:', error);
        this.$bvToast.toast(errorMessage, {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      }
    },

    async selectedQuotation(answerId) {
      try {
        this.setAnswerLoading(answerId, true);
        
        // Сначала сохраняем ставку клиента
        const form = this.getClientRateForm(answerId);
        const clientRate = form.client_rate;
        if (clientRate && clientRate > 0) {
          await this.saveClientRate(answerId);
        }
        
        // Затем утверждаем ставку
        const response = await api.call('post', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}/select`);
        
        if (response.data.success) {
          // Обновляем ответ в списке
          const answerIndex = this.answers.findIndex(a => a.id === answerId);
          if (answerIndex !== -1) {
            this.answers.splice(answerIndex, 1, response.data.answer);
          }

          this.$bvToast.toast(response.data.message || 'Ставка успешно утверждена клиентом', {
            title: 'Успешно',
            variant: 'success',
            solid: true
          });
          
          // Перезагружаем ответы для обновления статусов
          this.loadAnswers();
        }
      } catch (error) {
        let errorMessage = 'Ошибка при утверждении ставки';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }
        
        console.error('Ошибка утверждения ставки:', error);
        this.$bvToast.toast(errorMessage, {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.setAnswerLoading(answerId, false);
      }
    },

         calculateDiscountedCost(originalCost, discountRate) {
       const toNumber = (val) => {
         if (val === null || val === undefined) return NaN;
         if (typeof val === 'string') {
           const normalized = val.replace(/\s/g, '').replace(',', '.');
           return Number(normalized);
         }
         return Number(val);
       };

       const cost = toNumber(originalCost);
       const discount = toNumber(discountRate);
       if (!isFinite(cost) || !isFinite(discount) || discount <= 0) {
         return originalCost;
       }
       // Теперь discountRate - это фиксированная сумма, которую нужно вычесть
       return cost - discount;
     },

     calculateMargin(cost, clientRate) {
       const toNumber = (val) => {
         if (val === null || val === undefined || val === '') return NaN;
         if (typeof val === 'string') {
           const normalized = val.replace(/\s/g, '').replace(',', '.');
           return Number(normalized);
         }
         return Number(val);
       };

       const costNum = toNumber(cost);
       const clientRateNum = toNumber(clientRate);

       if (!isFinite(costNum) || !isFinite(clientRateNum) || costNum <= 0 || clientRateNum <= 0) {
         return '—';
       }

       // Маржинальность = ((Ставка клиента - Стоимость) / Ставка клиента) * 100
       const margin = ((clientRateNum - costNum) / clientRateNum) * 100;
       return margin.toFixed(2);
     },

     getMarginColor(cost, clientRate) {
       const margin = this.calculateMargin(cost, clientRate);
       
       if (margin === '—') return 'text-muted';
       
       const marginNum = parseFloat(margin);
       
       if (marginNum < 0) return 'text-danger'; // Убыток
       if (marginNum < 10) return 'text-warning-dark'; // Низкая маржинальность
       if (marginNum < 20) return 'text-info'; // Средняя маржинальность
       return 'text-success'; // Высокая маржинальность
     },

    async saveDiscount(answerId) {
      const answer = this.answers.find(a => a.id === answerId);

      const toNumber = (val) => {
        if (val === null || val === undefined) return NaN;
        if (typeof val === 'string') {
          const normalized = val.replace(/\s/g, '').replace(',', '.');
          return Number(normalized);
        }
        return Number(val);
      };

      const discount = toNumber(answer && answer.discount_rate);
      const delivery = toNumber(answer && answer.delivery_cost);

      if (!answer || !isFinite(discount) || discount <= 0) {
        this.$bvToast.toast('Введите корректную сумму скидки', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
        return;
      }

      // Проверяем, что скидка не больше стоимости доставки
      if (isFinite(delivery) && discount >= delivery) {
        this.$bvToast.toast('Скидка не может быть больше или равна стоимости доставки', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
        return;
      }

      this.$set(this.savingDiscount, answerId, true);

      try {
        const response = await api.call('put', `${API_ORDER_SERVICES_QUOTATION_ANSWERS}/${answerId}`, {
          discount_rate: discount
        });

        if (response.data.success) {
          // Обновляем ответ в списке
          const answerIndex = this.answers.findIndex(a => a.id === answerId);
          if (answerIndex !== -1) {
            this.answers.splice(answerIndex, 1, response.data.answer);
          }

          this.$bvToast.toast('Скидка успешно сохранена', {
            title: 'Успех',
            variant: 'success',
            solid: true
          });
        }
      } catch (error) {
        let errorMessage = 'Произошла ошибка при сохранении скидки';
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        this.$bvToast.toast(errorMessage, {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.$set(this.savingDiscount, answerId, false);
      }
    }
  }
}
</script>

<style scoped>
.quotation-answer-forms {
  margin-top: 20px;
  font-size: 0.875rem;
}

.answers-horizontal-scroll {
  overflow-x: auto;
  padding-bottom: 10px;
}

.answers-container {
  display: flex;
  gap: 15px;
  min-width: min-content;
}

.transport-type-answer-card {
  flex: 0 0 420px;
  min-width: 420px;
  background-color: #f8f9fa;
}

.transport-type-answer-card .border {
  height: 100%;
  background-color: #ffffff;
  padding: 0.75rem !important;
}

.transport-type-answer-card h6 {
  font-size: 0.8rem;
  margin-bottom: 0.75rem !important;
}

.answer-card {
  background-color: #ffffff;
  font-size: 0.8rem;
}

.answer-card .badge {
  font-size: 0.7rem;
}

.form-actions {
  border-top: 1px solid #dee2e6;
  padding-top: 10px;
}

/* Компактные лейблы */
.form-label-sm {
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

/* Уменьшаем отступы между строками формы */
.answer-form .row {
  margin-bottom: 0.5rem;
}

.answer-form .form-group {
  margin-bottom: 0.75rem;
}

/* Компактные кнопки */
.form-actions .btn {
  font-size: 0.8rem;
  padding: 0.25rem 0.75rem;
}

/* Компактные существующие ответы */
.existing-answers .answer-card {
  padding: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.existing-answers .btn {
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
}

/* Более компактные input'ы и select'ы */
.form-control-sm {
  font-size: 0.8rem;
}

/* Стили для карточки с информацией об ответе */
.answer-info {
  font-size: 0.85rem;
}

.answer-info .row {
  margin-bottom: 0.5rem;
}

.answer-info strong {
  font-weight: 600;
  color: #495057;
  text-transform: none !important;
}

/* Кастомная полоса прокрутки */
.answers-horizontal-scroll::-webkit-scrollbar {
  height: 8px;
}

.answers-horizontal-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.answers-horizontal-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.answers-horizontal-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Стили для одинаковой высоты блоков quotation-bill */
.quotation-bill {
  min-height: 375px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.quotation-bill-short {
  min-height: auto;
}

.quotation-bill .row:last-child {
  margin-top: auto;
}

/* Если нет автовывоза, добавляем отступ снизу для выравнивания */
.quotation-bill:not(:has(.col-md-7:last-child)) {
  padding-bottom: 20px;
}
</style> 